import { OperacaoGarantida } from './operacao-garantida.model';


export class OperacaoRepasseBndes extends OperacaoGarantida {

	public idProtocoloBNDES: string;
    public idPorteClienteFinal: number;
    public idNaturezaEmpresa: number;
	public idComplementoNaturezaEmpresa: number;
    public idModalidadeOperacionalBndes: number;
    public idCodigoPrograma: number;
    public nomePrograma: string;
    public numeroCertificadoRntrc: string;
    public dataPrimeiraAmortizacao: Date;
    public dataUltimaAmortizacao: Date;
    public contratoCobranca: number;
    public sistemaCobranca: string;
    public taxaSpreadAgente: number;
    public tipoFGI: string;
    public sistemaOrigem: string;
    public composicaoGarantia: string;
    public percentualCobertoGarantiaPrincipal: number;
    public principalGarantiaOperacao: number;
    public municipioInvestimento: string;
    public periodicidadeAmortizacao: number;



}

export const COMPOSICAO_GARANTIA = [

    {
      nome: 'Fidejussória prestada pelo(s) controlador(es)',
      codigo: 'FC'

    },
    {
      nome: 'Fidejussória prestada por terceiro(s)',
      codigo: 'FT'
    },
    {
      nome: 'Fidejussória prestada pelo(s) controlador(es) + Real',
      codigo: 'FR'
    }
    ,
    {
      nome: 'Fidejussória prestada pelo(s) controlador(es) + Fidejussória prestada por terceiro(s)',
      codigo: 'FF'
    }
    ,
    {
      nome: 'Fidejussória prestada por terceiro(s) + Real',
      codigo: 'TR'
    }
    ,
    {
      nome: 'Fidejussória prestada pelo(s) controlador(es) + Fidejussória prestada por terceiro(s) + Real',
      codigo: 'TT'
    },
    {
      nome: 'Real',
      codigo: 'RE'
    }
  ]

  export const PRINCIPAL_GARANTIA_OPERACAO = [

    {
      nome: 'Real',
      codigo: 1
    },
    {
      nome: 'Fidejussória',
      codigo: 2
    },
    {
      nome: 'Cessão/Vinculação de Receita (Reserva de meio de pagamento) (antigo código 05 no PGA)',
      codigo: 3
    },
    {
      nome: 'Seguro de Crédito',
      codigo: 5
    },
    {
      nome: 'Fiança entre Entidades',
      codigo: 6
    },
    {
      nome: 'Project Finance',
      codigo: 7
    },
    {
      nome: 'Penhor (Bens ou Ações) (antigo código 13 no PGA)',
      codigo: 8
    },
    {
      nome: 'Caução',
      codigo: 9
    },
    {
      nome: 'Propriedade Fiduciária (antigo código 04 no PGA)',
      codigo: 12
    },
    {
      nome: 'Hipoteca (antigo código 09 no PGA)',
      codigo: 13
    },
    {
      nome: 'Fiança',
      codigo: 14
    },
    {
      nome: 'Fiança Bancária',
      codigo: 15
    },
    {
      nome: 'Fiança Pessoal (antigo código 14 no PGA)',
      codigo: 16
    },
    {
      nome: 'Fiança Corporativa',
      codigo: 17
    },
    {
      nome: 'Aval (antigo código 10 no PGA)',
      codigo: 20
    },
    {
      nome: 'Endosso com Regresso',
      codigo: 21
    },
    {
      nome: 'Penhor de Ações',
      codigo: 22
    },
    {
      nome: 'Cessão Fiduciária de Direitos Creditórios',
      codigo: 23
    },
    {
      nome: 'Cessão Fiduciária de Direitos Emergentes',
      codigo: 24
    },
    {
      nome: 'Penhor de Direitos Creditórios (antigos códigos 06, 16 no PGA)',
      codigo: 25
    },
    {
      nome: 'Penhor de Direitos Emergentes',
      codigo: 26
    },
    {
      nome: 'Sem Garantia',
      codigo: 99
    }

  ]

  export const PERIODICIDADE_AMORTIZACAO = [

    {
      nome: 'Mensal',
      codigo: 1001
    },
    {
      nome: 'Trimestral',
      codigo: 1003
    },
    {
      nome: 'Semestral',
      codigo: 1005
    },
    {
      nome: 'Anual',
      codigo: 1006
    },
    {
      nome: 'Sem periodicidade',
      codigo: 1008
    }

  ]
